import _ from 'lodash'
import moment from 'moment'
import {date, makeRange} from '@eitje/utils'
import pluralize from 'pluralize'

export const calcInitialDate = fields => {
	const {close_weekday, close_monthday} = fields
	const {isWeekly, isMonthly} = getPeriodData(fields)
	if (isWeekly) return date().nextWeekday(close_weekday)
	if (isMonthly) return date().nextMonthday(close_monthday)
	return date()
}

export const deadlineActivated = props => {
	const initial = date(props.initial_date)
	return initial.startOf('day') <= date().startOf('day')
}

export const getOpenRange = props => {
	if (!deadlineActivated(props)) return makeRange(date().startOf('day'))

	const start = openStart(props).startOf('day')
	let end = openEnd(props, start)
	if (end) end = end.endOf('day')
	if (!end) end = '2050-01-01'
	const range = makeRange(start, end)
	return range
}

export const openStart = props => {
	const {startDate, endDate} = getPrevClosePeriod(props)
	const date = endDate || startDate
	return date.add(1, 'day')
}

export const openEnd = (props, start = date()) => {
	start = start.clone()
	const {max_periods_future} = props
	const {transCloseKind, isWeekly, isMonthly} = getPeriodData(props)
	const endDate = max_periods_future ? start.add(max_periods_future, transCloseKind) : null
	if (!endDate) return
	if (isWeekly || isMonthly) endDate.subtract(1, 'day')
	return endDate
}

export const getClosePeriod = (props, closeDate) => {
	let startDate
	let endDate
	const {min_periods_future, amt_periods} = props
	const {isWeekly, isDaily, isMonthly} = getPeriodData(props)

	if (isWeekly) {
		startDate = closeDate.clone().add(min_periods_future, 'weeks').startOf('isoWeek')

		endDate = startDate.clone().add(amt_periods, 'weeks').subtract(1, 'day')
	}

	if (isMonthly) {
		startDate = closeDate.clone().add(min_periods_future, 'months').startOf('month')
		endDate = startDate.clone().add(amt_periods, 'months').subtract(1, 'day')
	}

	if (isDaily) {
		startDate = closeDate.clone().add(min_periods_future, 'day').subtract(1, 'day')
	}

	return {startDate, endDate}
}

export const getNextClosePeriod = props => {
	const closeDate = nextCloseDate(props)
	return getClosePeriod(props, closeDate)
}

export const getPrevClosePeriod = props => {
	const closeDate = prevCloseDate(props)
	return getClosePeriod(props, closeDate)
}

export const nextCloseDate = props => {
	const {kind} = getPeriodData(props)
	let {amt_periods, initial_date} = props
	if (_.isString(initial_date)) initial_date = date(initial_date).clone()

	if (initial_date && initial_date instanceof moment) {
		if (initial_date > date()) return initial_date
	}

	const _date = prevCloseDate(props)
	if (!_date) return
	return _date.add(amt_periods, kind)
}

export const incrementCloseDate = (_date, props) => {
	const {kind, isDaily, isWeekly, isMonthly} = getPeriodData(props)
	const incrementAmount = isDaily ? 1 : props.amt_periods
	const newDate = date(_date).clone().add(incrementAmount, kind)
	if (isWeekly) {
		return newDate.weekday(props.close_weekday)
	} else if (isMonthly) {
		return newDate.date(props.close_monthday)
	}

	return newDate
}

const prevCloseDate = props => {
	const {close_weekday, close_monthday, amt_periods, initial_date} = props
	const {isWeekly, isDaily, kind} = getPeriodData(props)
	if (isDaily) return date().startOf('day')
	const _date = isWeekly ? date().prevWeekday(close_weekday) : date().prevMonthday(close_monthday)
	if (amt_periods < 2) return _date
	const diff = _date.diff(initial_date, kind)
	const unitsToSubtract = diff % amt_periods
	return _date.subtract(unitsToSubtract, kind)
}

const transCloseKinds = {daily: 'days', weekly: 'weeks', monthly: 'months'}

export const getPeriodData = ({close_kind = 'daily'}) => {
	if (!close_kind) close_kind = 'daily'
	const transCloseKind = transCloseKinds[close_kind]
	const singularTransKind = pluralize.singular(transCloseKind)
	const isDaily = close_kind == 'daily'
	const isWeekly = close_kind == 'weekly'
	const isMonthly = close_kind == 'monthly'
	return {isDaily, isWeekly, isMonthly, transCloseKind, kind: transCloseKind, singularTransKind}
}
